import React, { FC, useCallback, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useFormik } from "formik";
import useDarkMode from "../../../hooks/useDarkMode";
import AuthContext from "../../../contexts/authContext";
import "./Login.css";
// import Logo from "../../../assets/login/logo.png";
import Logo from "../../../assets/logos/vyu.png";
import { getUserDataWithUsername } from "../../../common/data/userDummyData";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store/store";
import { fetchDashboardInfoForUserId } from "../../../store/dashboardForUserId";
import { fetchAllDashboardsData } from "../../../store/apiSlice";
import { Auth0ContextInterface, useAuth0, User } from "@auth0/auth0-react";
import ForgotPassword from "./ForgotPassword";
import ToastComponent from "../../../components/ToastComponent";
import PersonImage from "../../../assets/login/vyuPersonImg.png";
interface ILoginHeaderProps {
  isNewUser?: boolean;
}
const LoginHeader: FC<ILoginHeaderProps> = ({ isNewUser }) => {
  if (isNewUser) {
    return (
      <>
        <div className="text-center h1 fw-bold mt-5">Create Account,</div>
        <div className="text-center h4 text-muted mb-5">
          Sign up to get started!
        </div>
      </>
    );
  }
  return (
    <>
      <div className="text-center h1 fw-bold mt-5">Welcome,</div>
      <div className="text-center h4 text-muted mb-5">Sign in to continue!</div>
    </>
  );
};
LoginHeader.defaultProps = {
  isNewUser: false,
};

interface LoginResponse {
  loggedInUser: any;
  companyDetails: any;
  userName: string;
  success: boolean;
  token?: string;
  error?: string;
}

interface ILoginProps {
  isSignUp?: boolean;
}

interface LoginResponse {
  loggedInUser: any;
  userName: string;
  success: boolean;
  token?: string;
  error?: string;
}
interface ILoginProps {
  isSignUp?: boolean;
}
const Login: FC<ILoginProps> = ({ isSignUp }) => {
  type companyType = {
    id: number;
    companyName: string;
    companyLogo: string;
  };
  type PayloadType = {
    preferred_locale?: string;
    phone?: string;
    last_name?: string;
    guid?: string;
    groups?: string;
    first_name?: string;
    email?: string;
    username?: string;
    iat?: number | undefined;
    sub?: string | undefined;
    iss?: string | undefined;
    jti?: string | undefined;
    nbf?: number | undefined;
    exp?: number | undefined;
  };
  const { setUser } = useContext(AuthContext);
  const [showSignin, setShowSignin] = useState(true);
  const [showSignup, setShowSignup] = useState(false);
  const [signUpSuccess, setSignUpSuccess] = useState("");
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [repassword, setRepassword] = useState("");
  const [error, setError] = useState<string>("");
  const [signUpError, setSignUpError] = useState<string>("");
  const [companies, setCompanies] = useState<companyType[]>([]);
  const [companyId, setCompanyId] = useState<companyType>();
  const [showForgotPassword, setShowForgotPassword] = useState<boolean>(false);
  const { user, isAuthenticated }: Auth0ContextInterface = useAuth0();
  const togleForm = () => {
    getAllCompanies();
    setShowSignin(!showSignin);
    setShowSignup(!showSignup);
    setShowForgotPassword(false);
    setSignUpSuccess("");
  };
  const { darkModeStatus } = useDarkMode();

  const [signInPassword, setSignInPassword] = useState<boolean>(false);
  const [singUpStatus, setSingUpStatus] = useState<boolean>(!!isSignUp);
  const dispatch: AppDispatch = useDispatch();
  const { dashboardData, apiStatus, apiError } = useSelector(
    (state: RootState) => state.apiDashboardForUserId
  );
  const vyu_api_url = process.env.REACT_APP_VYU_API_URL;
  const navigate = useNavigate();
  const handleOnClick = useCallback(() => navigate("/"), [navigate]);

  const usernameCheck = (username: string) => {
    return !!getUserDataWithUsername(username);
  };

  const passwordCheck = (username: string, password: string) => {
    return getUserDataWithUsername(username).password === password;
  };

  const resetFormValues = () => {
    setFname("");
    setLname("");
    setEmail("");
    setPassword("");
    setRepassword("");
    setCompanyId(undefined);
  };

  const formik = useFormik({
    initialValues: {
      loginUsername: "",
      loginPassword: "",
      email: "",
      fname: "",
      lname: "",
      password: "",
      repassword: "",
      companyId: 0,
    },
    validate: (values) => {
      const errors: Record<string, string> = {};

      if (showSignin) {
        console.log("Entered validate", values);

        // Sign In validation
        if (!values.loginUsername) {
          errors.loginUsername = "Username is required.";
        }
        if (!values.loginPassword) {
          errors.loginPassword = "Password is required.";
        }
      } else {
        console.log("Entered else validate", values);
        // Sign Up validation
        if (!values.fname) {
          console.log("validating fname");

          errors.fname = "First name is required.";
        }
        if (!values.lname) {
          console.log("validating lname");
          errors.lname = "Last name is required.";
        }
        if (!values.email) {
          console.log("validating email");
          errors.email = "Email is required.";
        } else if (
          !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
        ) {
          console.log("validating email else");
          errors.email = "Invalid email address.";
        }
        if (!values.password) {
          console.log("validating password");
          errors.password = "Password is required.";
        }
        if (!values.repassword) {
          console.log("validating repassword");
          errors.repassword = "Please confirm your password.";
        } else if (values.password !== values.repassword) {
          console.log("validating repassword else block");
          errors.repassword = "Passwords do not match.";
        }
        if (!values.companyId || values.companyId === 0) {
          console.log("validating companyId");
          errors.companyId = "Please select a company.";
        }
      }
      return errors;
    },

    validateOnChange: false,
    onSubmit: async (values) => {
      console.log(
        "Entered Onsubmit, current mode showSignin:",
        showSignin,
        "Formik values:",
        values
      );
      if (showSignin) {
        // console.log("Submitting form with values:", values); // Debugging log
        const email = values.loginUsername;
        const password = values.loginPassword;
        try {
          const response = await fetch(`${vyu_api_url}/user/authentication`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ email, password }),
          });
          if (response.status === 200) {
            const data: LoginResponse = await response.json();
            if (data.token) {
              console.log("companyInfo in login:", data.companyDetails);

              localStorage.setItem("token", data.token);
              localStorage.setItem(
                "userInfo",
                JSON.stringify(data.loggedInUser)
              );

              localStorage.setItem(
                "companyInfo",
                JSON.stringify(data.companyDetails)
              );
              formik.resetForm();
              navigate("/dashboard", { state: data });

              let response = dispatch(
                fetchAllDashboardsData(
                  `${vyu_api_url}/dashboard/getAllDashboardForCurrentUser`
                )
              );
              response.then((result: any) => {
                const dashboardData = result.payload.obj;
                const defaultDashboard = dashboardData.find(
                  (dat: any) => dat.isDefault
                );
                if (defaultDashboard) {
                  dispatch(
                    fetchDashboardInfoForUserId(
                      `${vyu_api_url}/dashboard/getDashboardInfoForUserById?dashboardId=${defaultDashboard.id}`
                    )
                  );
                }
              });
            }
          } else {
            setError("Login failed. Please check your credentials.");
          }
        } catch (error) {
          console.error("Error:", error);
          setError("An error occurred during login.");
        }
      } else {
        console.log(
          "Submitting SIGNUP form with Formik values:",
          values.email, // from formik.values
          values.password, // from formik.values
          values.repassword, // from formik.values
          values.fname, // from formik.values
          values.lname, // from formik.values
          values.companyId // from formik.values
        );

        // Signup functionality
        if (values.password !== values.repassword) {
          setSignUpError("Passwords do not match.");
          return;
        }

        try {
          const response = await fetch(`${vyu_api_url}/user/createUser`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              firstName: values.fname,
              lastName: values.lname,
              companyId: values.companyId,
              email: values.email,
              password: values.password,
            }),
          });
          if (response.status === 201) {
            formik.resetForm();
            resetFormValues();
            togleForm();
            setSignUpSuccess("Signup Success, Login to continue!");
            setSignUpError("");
          } else {
            const errorData = await response.json();
            setSignUpError(errorData.error || "Signup failed.");
          }
        } catch (error) {
          console.error("Signup Error:", error);
          setSignUpError("An error occurred during signup.");
        }
      }
    },
  });

  // const signInUsingAuth0 = async () => {
  //   // @ts-ignore
  //   let userName = user.password;
  //   // @ts-ignore
  //   let email = user.email;
  //   //   ignore password checking as user authenticated using sso-auth0
  //   try {
  //     const response = await fetch(`${vyu_api_url}/user/auth0Authentication`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({ email, password }),
  //     });
  //     if (response.status === 200) {
  //       const data: LoginResponse = await response.json();
  //       if (data.token) {
  //         // Authentication successful, store JWT token
  //         localStorage.setItem("token", data.token);
  //         localStorage.setItem("userInfo", JSON.stringify(data.loggedInUser));
  //         setError("");
  //         let currentUser = data.loggedInUser;
  //         console.log(currentUser);

  //         if (
  //           currentUser.roles.length === 0 &&
  //           currentUser.groups.length === 0
  //         ) {
  //           navigate("/accessForm");
  //         } else navigate("/home");
  //       }
  //     } else {
  //       // Authentication failed, display error message
  //       setError(response.statusText || "Invalid email or password.");
  //     }
  //   } catch (e) {
  //     console.log("error occurred ", e);
  //   }
  // };
  // console.log(isAuthenticated);
  // if (isAuthenticated) {
  //   signInUsingAuth0();
  // }

  const handleChange = (e: any) => {
    const { id, value } = e.target;
    setCompanyId({ id: value, companyLogo: "", companyName: "" });
  };
  const getAllCompanies: any = async () => {
    try {
      const response = await fetch(`${vyu_api_url}/company/getAll`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      setCompanies(data.obj);
    } catch (e) {
      console.error("Error:", error);
      setSignUpError("Unable to fetch Organisation list.");
    }
  };

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const handleContinue = () => {
    setIsLoading(true);
    setTimeout(() => {
      setSignInPassword(true);
      setIsLoading(false);
    }, 1000);
  };

  const handleForgot = () => {
    setShowSignin(false);
    setShowSignup(false);
  };

  const handleForgotClick = () => {
    setShowForgotPassword(true);
  };

  const handleBackToLogin = () => {
    setShowForgotPassword(false);
  };

  return (
    <div className="login-page d-flex w-100 h-100 position-fixed bg-white">
      <div className="complete-section">
        <div className="left-section">
          <div className="form-container">
            <img src={Logo} className="logo" alt="Logo" />
            <div className="form-div">
              {showSignin && !showForgotPassword && (
                <form onSubmit={formik.handleSubmit}>
                  {signUpSuccess && (
                    <div className="signup-message">{signUpSuccess}</div>
                  )}
                  <div className="input-pair mb-3">
                    <label htmlFor="email" className="form-label">
                      Email
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="loginUsername"
                      name="loginUsername"
                      value={formik.values.loginUsername}
                      onChange={formik.handleChange}
                      placeholder="Enter your Email"
                      required
                    />
                  </div>
                  <div className="input-pair mb-3">
                    <label htmlFor="password" className="form-label">
                      Password
                    </label>
                    <input
                      type="password"
                      className="form-control"
                      id="loginPassword"
                      name="loginPassword"
                      value={formik.values.loginPassword}
                      // onChange={formik.handleChange}
                      onChange={(e) => {
                        setError("");
                        formik.handleChange(e);
                      }}
                      placeholder="Enter your Password"
                      minLength={8}
                      pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_]).{8,}"
                      title="Must contain at least one number, one uppercase and lowercase letter, one special character, and at least 8 or more characters"
                      required
                    />
                    <div
                      onClick={handleForgotClick}
                      className="d-block forgot-button text-end text-primary mt-2"
                    >
                      Forgot password?
                    </div>
                  </div>
                  {error && <div className="login-error-message">{error}</div>}
                  <button type="submit" className="btn btn-primary w-100">
                    Sign In
                  </button>
                  {showSignin && (
                    <div className="sign-up-div">
                      <span className="no-account">Don't have an account?</span>
                      <button onClick={togleForm} className="btn btn-primary">
                        Sign up
                      </button>
                    </div>
                  )}
                </form>
              )}

              {showForgotPassword && (
                <ForgotPassword onBack={handleBackToLogin} />
              )}
              {showSignup && (
                <form onSubmit={formik.handleSubmit}>
                  <label htmlFor="company" className="form-label">
                    Organisation
                  </label>
                  <select
                    id="companyId"
                    name="companyId" // Ensure name matches formik.initialValues key
                    className="form-select mb-3"
                    value={formik.values.companyId} // Use formik's value
                    onChange={(e) => {
                      // Use formik.setFieldValue for proper type (number)
                      formik.setFieldValue(
                        "companyId",
                        parseInt(e.target.value, 10) || 0
                      );
                      setSignUpError(""); // Clear specific error if you want
                    }}
                    onBlur={formik.handleBlur} // Optional: for touched state
                    required
                  >
                    <option value={0} disabled>
                      {" "}
                      {/* Make value 0 to match initial/default */}
                      Select Organisation
                    </option>
                    {companies.map((company) => (
                      <option key={company.id} value={company.id}>
                        {company.companyName}
                      </option>
                    ))}
                  </select>
                  {formik.touched.companyId && formik.errors.companyId ? (
                    <div className="login-error-message">
                      {formik.errors.companyId}
                    </div>
                  ) : null}
                  <div className="d-flex flex-row gap-3">
                    <div className="input-pair flex-fill">
                      <label htmlFor="fName" className="form-label">
                        First Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="fname"
                        name="fname" // Matches formik.initialValues.fname
                        value={formik.values.fname}
                        onChange={(e) => {
                          formik.handleChange(e);
                          setSignUpError(""); // Clear general signup error on input change
                        }}
                        onBlur={formik.handleBlur}
                        placeholder="First Name"
                        required
                      />
                      {formik.touched.fname && formik.errors.fname ? (
                        <div className="login-error-message">
                          {formik.errors.fname}
                        </div>
                      ) : null}
                    </div>
                    <div className="input-pair flex-fill">
                      <label htmlFor="lName" className="form-label">
                        Last Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="lname"
                        name="lname"
                        value={formik.values.lname}
                        onChange={(e) => {
                          formik.handleChange(e);
                          setSignUpError("");
                        }}
                        onBlur={formik.handleBlur}
                        placeholder="Last Name"
                        required
                      />
                      {formik.touched.lname && formik.errors.lname ? (
                        <div className="login-error-message">
                          {formik.errors.lname}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="input-pair mb-3">
                    <label htmlFor="email" className="form-label">
                      Email
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="email" // This id is fine
                      name="email" // Matches formik.initialValues.email
                      value={formik.values.email}
                      onChange={(e) => {
                        formik.handleChange(e);
                        setSignUpError("");
                      }}
                      onBlur={formik.handleBlur}
                      placeholder="Enter your Email"
                      required
                    />
                    {formik.touched.email && formik.errors.email ? (
                      <div className="login-error-message">
                        {formik.errors.email}
                      </div>
                    ) : null}
                  </div>
                  <div className="input-pair mb-3">
                    <label htmlFor="password" className="form-label">
                      Password
                    </label>
                    <input
                      type="password"
                      className="form-control"
                      id="password" // This id is fine
                      name="password" // Matches formik.initialValues.password
                      value={formik.values.password}
                      onChange={(e) => {
                        formik.handleChange(e);
                        setSignUpError("");
                      }}
                      onBlur={formik.handleBlur}
                      placeholder="Enter your Password"
                      pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_]).{8,}"
                      title="Must contain at least one number, one uppercase and lowercase letter, one special character, and at least 8 or more characters"
                      required
                    />
                    {formik.touched.password && formik.errors.password ? (
                      <div className="login-error-message">
                        {formik.errors.password}
                      </div>
                    ) : null}
                  </div>
                  <div className="input-pair mb-3">
                    <label htmlFor="repassword" className="form-label">
                      Re-Enter Password
                    </label>
                    <input
                      type="password"
                      className="form-control"
                      id="repassword"
                      name="repassword"
                      value={formik.values.repassword}
                      onChange={(e) => {
                        formik.handleChange(e);
                        setSignUpError("");
                      }}
                      onBlur={formik.handleBlur}
                      placeholder="Re-Enter your Password"
                      pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_]).{8,}"
                      title="Must contain at least one number, one uppercase and lowercase letter, one special character, and at least 8 or more characters"
                      required
                    />
                    {formik.touched.repassword && formik.errors.repassword ? (
                      <div className="login-error-message">
                        {formik.errors.repassword}
                      </div>
                    ) : null}
                  </div>
                  {signUpError && (
                    <div className="login-error-message">{signUpError}</div>
                  )}
                  {signUpSuccess && (
                    <div className="login-error-message">{signUpSuccess}</div>
                  )}
                  <button type="submit" className="btn btn-primary w-100">
                    Sign Up
                  </button>
                  {showSignup && (
                    <div className="sign-up-div">
                      <span>Already have an account?</span>
                      <button onClick={togleForm} className="btn btn-primary">
                        Sign In
                      </button>
                    </div>
                  )}
                </form>
              )}
            </div>
          </div>
        </div>
        <div className="right-section">
          <div className="right-section-text">
            <h2 className="right-section-title">Welcome Back</h2>
            <p className="right-section-subtitle">See more. Achieve more.</p>
            <p className="right-section-subtitle">
              Unlock the power of insights with VYU
            </p>
          </div>
          <img
            src={PersonImage}
            alt="Dashboard preview"
            className="right-section-image"
          />
        </div>
      </div>
      <ToastComponent />
    </div>
  );
};

Login.propTypes = {
  isSignUp: PropTypes.bool,
};
Login.defaultProps = {
  isSignUp: false,
};

export default Login;
